export default __webpack_public_path__ + "static/media/spr-components-light-large.9dabe6ac.png";